<template>
  <div>
    <el-input-number
      v-model="form.length"
      :controls="false"
      :precision="2"
      :min="0"
      size="mini"
    />
    <span>CM</span>
    <span>*</span>
    <el-input-number
      v-model="form.width"
      :controls="false"
      :precision="2"
      :min="0"
      size="mini"
    />
    <span>CM</span>
    <span>*</span>
    <el-input-number
      v-model="form.height"
      :controls="false"
      :precision="2"
      :min="0"
      size="mini"
    />
    <span>CM</span>
  </div>
</template>

<script>
export default {
  name: 'CargoLengthWidthHeight',
  props: {
    form: { type: Object, required: true }
  }
}
</script>

<style>
</style>
